import { Box, Flex, ListItem, Text } from "@chakra-ui/react";

export function currencyFilter(value: number) {
  if (typeof value !== "number") {
    return "-";
  }

  const isNegative = value < 0;
  const displayValue = value < 0 ? -value : value;
  return `${isNegative ? "-" : ""}$${displayValue
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+(\.|$))/g, "$1,")}`;
}

const BankAccountRow = ({ account }: { account: any }) => {
  return (
    <ListItem
      mb="8px"
      borderWidth="1.5px"
      borderColor="#E0E0E0"
      borderRadius="10px"
      py="8px"
      px="16px"
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Box>
          <Text fontSize="15px" fontWeight="500">
            {account.name}
          </Text>
          <Text fontSize="13px">Ending in {account.mask}</Text>
        </Box>
        <Text fontSize="15px" fontWeight="500">
          {currencyFilter(account.available_balance)}
        </Text>
      </Flex>
    </ListItem>
  );
};

export default BankAccountRow;
